import React, { useContext } from "react";
import OrderBarcode from "./OrderBarcode";

import {
  _t,
  getSystemSettings,
} from "../../../../functions/Functions";
import { SettingsContext } from "../../../../contexts/Settings";

const OnlineOrderBarcodePrint = ({
  barcodePrintRef,
  foodGroupsToPrint,
  checkOrderDetails,
}) => {
  const { generalSettings } = useContext(SettingsContext);
  
  return (
    <>
      {/*barcode print*/}
      <div id="online-barcode" className="d-none">
        {checkOrderDetails?.item &&
          checkOrderDetails.item.theBranch?.barcode_enable && (
            barcodePrintRef && (
              <div ref={barcodePrintRef}>
                <div className="fk-print">
                  <div className="container-fluid">
                    <div className="row p-0">
                      {foodGroupsToPrint &&
                        Object.keys(foodGroupsToPrint)?.length &&
                        Object.keys(foodGroupsToPrint).map((theGrp) => (
                          foodGroupsToPrint[theGrp] && Object.keys(foodGroupsToPrint[theGrp])?.length && Object.keys(foodGroupsToPrint[theGrp]).map((grp)=>(
                            foodGroupsToPrint[theGrp][grp] && foodGroupsToPrint[theGrp][grp]?.length && foodGroupsToPrint[theGrp][grp].map((printItem, ind) =>
                              Array.from({ length: printItem.quantity || 0 }).map(
                                (_, i) => {
                                  let value = "";
                                  if (checkOrderDetails.item.token) {
                                    const orderNoEnabled= parseInt(getSystemSettings(generalSettings, "order_no")) === 1;
    
                                    const sourceString = orderNoEnabled && checkOrderDetails.item?.document_no
                                      ? String(checkOrderDetails.item?.document_no)
                                      : (String(checkOrderDetails.item.token) ?? "");
                                    const index = sourceString.lastIndexOf("-");
                                    const token = index !== -1 ? sourceString.slice(index + 1) : sourceString;
                                    value += token;
                                  }
                                  if (printItem?.food_item_id) {
                                    value += "-" + printItem.food_item_id;
                                    if(printItem?.variation_id && printItem?.variation){
                                      value += "." + printItem.variation_id
                                    }
                                  }
                                  if (checkOrderDetails.item?.waiter_id) {
                                    value += "-" + checkOrderDetails.waiter_id;
                                  }
                                  value += "-" + i + 1;

                                  return (
                                    <div
                                      key={`${ind}-${i}`}
                                      className={`break-after-page col-6`}
                                    >
                                      <div className="d-flex text-break align-items-center justify-content-between mx-1">
                                        <span className="fk-print-text text-uppercase font-weight-md sm-text mr-1">
                                          {(checkOrderDetails.item?.token &&
                                            checkOrderDetails.item.token) ??
                                            " - "}
                                        </span>
                                        {checkOrderDetails.item?.waiter_name && (
                                          <span className="fk-print-text text-uppercase font-weight-md sm-text">
                                            {(checkOrderDetails.item?.waiter_name &&
                                              checkOrderDetails.item.waiter_name) ??
                                              ""}
                                          </span>
                                        )}
                                      </div>
                                      <div className="fk-print-text w-100 text-center">
                                        <OrderBarcode
                                          value={value}
                                          text={printItem.food_item}
                                          height="15"
                                          width={0.75}
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            )
                          ))
                          )
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        }
      </div>
    </>
  );
};

export default OnlineOrderBarcodePrint;
